import React from 'react';
import { Radio as AndtRadio, Space, Typography } from 'antd';
import { CheckboxOptionType } from 'antd/lib/checkbox';

interface RadioProps {
  id: string;
  placeholder: string;
  defaultValue: any;
  options: CheckboxOptionType[];
  isDisabled?: boolean;
}

const { Text } = Typography;

export const Radio: React.FC<RadioProps> = ({
  id,
  placeholder,
  options,
  defaultValue,
  isDisabled,
}) => (
  <Space>
    <Text>{placeholder}</Text>
    <AndtRadio.Group
      id={id}
      options={options}
      disabled={isDisabled}
      defaultValue={defaultValue}
    />
  </Space>
);
